import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Video, Plus, Copy, ArrowUpRight, Lock, Trash2, RefreshCw, Calendar, Shield } from 'lucide-react';
import { meetApi, meetingLink, copyText } from './meetApi';
import './MeetPage.css';
export default function MeetPage() {
  const [rooms, setRooms] = useState([]);
  const [title, setTitle] = useState('');
  const [protectedRoom, setProtectedRoom] = useState(true);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  const [created, setCreated] = useState(null);
  const load = async () => {
    setRooms((await meetApi.get('/')).data);
  };
  useEffect(() => {
    load().catch(() => setError('Не удалось загрузить встречи. Обновите страницу.')).finally(() => setLoading(false));
  }, []);
  async function action(fn) {
    setError('');
    setNotice('');
    setBusy(true);
    try {
      await fn();
    } catch (e) {
      setError(e.response?.data?.message || 'Не удалось выполнить действие. Попробуйте ещё раз.');
    } finally {
      setBusy(false);
    }
  }
  const copy = text => action(async () => {
    await copyText(text);
    setNotice('Скопировано');
  });
  return <div className="meet-app meet-dashboard">
        <header className="meet-top"><Link to="/" className="meet-brand"><Video size={23} /> Календарь <span>/ Встречи</span></Link><Link to="/join-meet">Войти по коду <ArrowUpRight size={16} /></Link></header>
        <main className="meet-container">
            <div className="meet-dashboard-grid">
                <section className="meet-card meet-create"><div className="meet-icon"><Video /></div><h2>Новая встреча</h2><p>Создайте комнату и пригласите участников.</p>
                    <form onSubmit={e => {
            e.preventDefault();
            action(async () => {
              const {
                data
              } = await meetApi.post('/', {
                title,
                protected: protectedRoom
              });
              setCreated(data);
              setTitle('');
              await load();
            });
          }}>
                        <label>Название встречи<input required maxLength={120} value={title} onChange={e => setTitle(e.target.value)} placeholder="Например, индивидуальная консультация" /></label>
                        <label className="meet-check"><input type="checkbox" checked={protectedRoom} onChange={e => setProtectedRoom(e.target.checked)} /><span><b>Защитить паролем</b><small>Дополнительная защита входа в комнату</small></span><Lock size={18} /></label>
                        <button className="meet-primary" disabled={busy || !title.trim()}><Plus size={18} /> Создать встречу</button>
                    </form>
                </section>
                <section className="meet-card meet-guide"><Shield size={30} /><p>У каждой встречи свой код. Участники разных комнат не видят и не слышат друг друга.</p><div><span>01</span> Создайте встречу</div><div><span>02</span> Отправьте ссылку и пароль отдельно</div><div><span>03</span> Включите микрофон, когда будете готовы</div><small>До 6 участников · P2P · Без серверной записи</small></section>
            </div>
            {error && <p role="alert" className="meet-error">{error}</p>}{notice && <p role="status" className="meet-notice">{notice}</p>}
            {created && <section className="meet-card meet-invite"><h2>Приглашение готово</h2><p>{created.title}</p><label>Ссылка<input readOnly value={meetingLink(created.code)} /></label>{created.password && <label>Пароль — сохраните сейчас, позже его можно только заменить<input readOnly value={created.password} /></label>}<div className="meet-actions"><button onClick={() => copy(meetingLink(created.code))}><Copy size={16} /> Ссылка</button>{created.password && <button onClick={() => copy(created.password)}>Скопировать пароль</button>}<Link className="meet-primary" to={`/join-meet/${created.code}`}>Открыть встречу <ArrowUpRight size={16} /></Link><button onClick={() => setCreated(null)}>Закрыть</button></div></section>}
            <section className="meet-history"><div className="meet-section-heading"><h2>Мои встречи <span>{rooms.length}</span></h2><span>Ссылки можно использовать повторно</span></div>
                {loading ? <p role="status">Загружаем встречи…</p> : !rooms.length ? <div className="meet-empty"><Calendar size={30} /><h3>Здесь будут ваши встречи</h3><p>Создайте первую комнату — она сохранится в истории.</p></div> : rooms.map(room => <article className="meet-history-row" key={room.id}><div className="meet-icon"><Video size={20} /></div><div className="meet-room-info"><h3>{room.title} {room.has_password && <Lock size={14} />}</h3><p>{new Date(room.created_at).toLocaleDateString('ru-RU')} · {room.last_used_at ? `Последний вход ${new Date(room.last_used_at).toLocaleDateString('ru-RU')}` : 'Ещё не использовалась'}</p><code>{room.code}</code></div><div className="meet-actions"><button title="Скопировать ссылку" aria-label={`Скопировать ссылку: ${room.title}`} onClick={() => copy(meetingLink(room.code))}><Copy size={17} /></button><button disabled={busy} title="Новый пароль" aria-label={`Новый пароль: ${room.title}`} onClick={() => {
              if (window.confirm('Заменить пароль? Текущие участники будут отключены в течение 5 секунд.')) action(async () => {
                setCreated((await meetApi.post(`/${room.id}/password`)).data);
                await load();
              });
            }}><RefreshCw size={17} /></button><button disabled={busy} title="Удалить встречу" aria-label={`Удалить встречу: ${room.title}`} onClick={() => {
              if (window.confirm('Удалить встречу? Ссылка перестанет работать, участники будут отключены в течение 5 секунд.')) action(async () => {
                await meetApi.delete(`/${room.id}`);
                if (created?.id === room.id) setCreated(null);
                await load();
              });
            }}><Trash2 size={17} /></button><Link to={`/join-meet/${room.code}`} className="meet-primary">Войти <ArrowUpRight size={16} /></Link></div></article>)}
            </section>
        </main>
    </div>;
}
